import { FC } from 'react';
import { Headline } from './Headline.tsx';

export type SlideItemProps = {
  alignment?: 'text-right text-end' | 'text-center' | 'text-left';
  backgroundImage?: string;
  className?: string;
  videoUrl?: string;
};

export const SlideItem: FC<SlideItemProps> = (props) => (
  <div
    className={'ltn__slide-item-2 bg-image ' + props.className}
    style={{
      backgroundImage: `url(${props.backgroundImage})`,
    }}
  >
    <div className={'ltn__slide-item-inner ' + props.alignment}>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12 align-self-center'>
            <div className='slide-item-info'>
              <div className='slide-item-info-inner ltn__slide-animation'>
                {props.videoUrl && (
                  <div className='slide-video mb-50'>
                    <video autoPlay muted loop playsInline>
                      <source src={props.videoUrl} type='video/mp4' />
                    </video>
                  </div>
                )}
                <Headline />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
